/**
 * @graph-stack product-innovation-lab
 * @graph-domain Engineering
 * @graph-business 共有デザインシステムの useTheme を PIL の localStorage キー 'pilab-theme' で束ねるラッパー。dark/light/system の 3 モード対応・OS 設定連動は共有実装に委譲する
 * @graph-connects none
 */
import { useTheme as useSharedTheme } from '@cortex/web-design-system/hooks/useTheme';

/**
 * PIL のテーマ管理フック。storageKey 'pilab-theme' で共有 useTheme を呼ぶ。
 * @graph-connects none
 */
export function useTheme(): ReturnType<typeof useSharedTheme> {
  return useSharedTheme('pilab-theme');
}
